import googleAnalytics from '@analytics/google-analytics';
import googleTagManager from '@analytics/google-tag-manager';
import { clarity, metaPixel } from '@zala-team/ui-web';
import Analytics from 'analytics';
import doNotTrack from 'analytics-plugin-do-not-track';

export const analytics = Analytics({
	app: 'zala-website',
	plugins:
		import.meta.env.PUBLIC_ENV__ANALYTICS_ENABLED === 'true'
			? [
					doNotTrack(),
					clarity({ projectId: import.meta.env.PUBLIC_ENV__CLARITY_PROJECT_ID }),
					googleTagManager({
						containerId: import.meta.env.PUBLIC_ENV__GOOGLE_TAG_MANAGER_KEY,
					}),
					googleAnalytics({
						measurementIds: [import.meta.env.PUBLIC_ENV__GOOGLE_ANALYTICS_KEY],
					}),
					metaPixel({ pixelId: import.meta.env.PUBLIC_ENV__META_PIXEL_ID }),
				]
			: [],
});

export default analytics;
